import DeckMetrics from './DeckMetrics';

export default DeckMetrics;
